/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import { shopSaga } from './sagas';
import shopSlice, { SHOP_KEY_IN_STORE } from './slice';

export class ShopModule {
	getRootKeyInStore(): string {
		return SHOP_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return shopSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return shopSaga;
	}
}

export const moduleInstance = new ShopModule();
